export default {
    type: 'widget',
    config: {
        defaultWidth: 80,
        icon: 'clock',
        demotable: true
    },
    default: {},
    unique: [],
    sort: 'duration',
    lang: {
        name: 'Duration',
        views: ['list', 'sheet', 'grid'],
        category: 'Game',
        description: 'Publisher set duration range for the game.'
    },
    filters: ['official.duration']
}